import { MenuProvider } from './MenuContext';
import { AuthProvider } from './AuthContext';
import { AppProvider } from '@/context/AppContext';

const ContextsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthProvider>
      <AppProvider>
        <MenuProvider>{children}</MenuProvider>
      </AppProvider>
    </AuthProvider>
  );
};

export { ContextsProvider };
